module.exports = __webpack_public_path__ + "static/media/youtubeplayer.b434e39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/youtubeplayer.png
// module id = 245
// module chunks = 0